export default __webpack_public_path__ + "static/media/june2023-2.b75b304a.jpg";